(() => {
  if (customElements.get('trek-fit-selector')) return;
  class TrekFitSelector extends HTMLElement {
    static resolve(state) {
      if (state.generation === 'unsure' || (state.generation === 'v2' && state.size === 'unsure')) return { key: 'help' };
      if (!state.generation) return { next: 'generation' };
      if (state.generation === 'v2' && !state.size) return { next: 'size' };
      const fit = state.generation === 'legacy' ? 'legacy' : state.size;
      if (fit !== 'midsize') return state['water-wide'] ? { key: fit, addon: state['water-wide'] === 'sink' ? `sink-${fit}` : null } : { next: 'water-wide' };
      const water = state['water-mid'];
      if (!water) return { next: 'water-mid' };
      if (water === 'standard') return { key: '52064097632536' };
      if (water === 'own') return { key: '52047933735192' };
      if (water === 'complete') {
        const variants = { ash: '52047933636888', glacier: '52047933669656', slate: '52047933702424' };
        return variants[state.color] ? { key: variants[state.color] } : { next: 'color' };
      }
      return { next: 'water-mid' };
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.state = {};
      this.querySelector('.trek-fit__interactive').hidden = false;
      this.addEventListener('change', (event) => {
        const input = event.target.closest('input[data-choice]');
        if (!input) return;
        const group = input.dataset.choice;
        const downstream = { generation: ['size', 'water-wide', 'water-mid', 'color'], size: ['water-wide', 'water-mid', 'color'], 'water-wide': [], 'water-mid': ['color'], color: [] };
        downstream[group].forEach(key => {
          delete this.state[key];
          this.querySelectorAll(`input[data-choice="${key}"]`).forEach(item => { item.checked = false; });
        });
        this.state[group] = input.value;
        this.update();
      });
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.state = {};
        this.querySelectorAll('input[data-choice]').forEach(input => { input.checked = false; });
        this.update();
        this.querySelector('input[data-choice="generation"]').focus();
      });
      this.preservePreview(this);
    }
    preservePreview(root) {
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (!preview) return;
      root.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('preview_theme_id', preview);
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      });
    }
    update() {
      const s = this.state;
      const fit = s.generation === 'legacy' ? 'legacy' : s.size;
      const resolved = TrekFitSelector.resolve(s);
      const visible = {
        generation: true,
        size: s.generation === 'v2',
        'water-wide': s.generation === 'legacy' || (s.generation === 'v2' && s.size === 'full'),
        'water-mid': s.generation === 'v2' && s.size === 'midsize',
        color: fit === 'midsize' && s['water-mid'] === 'complete'
      };
      this.querySelectorAll('[data-step]').forEach(step => { step.hidden = !visible[step.dataset.step]; });
      const result = this.querySelector('[data-result]');
      result.replaceChildren();
      if (resolved.key) {
        const template = this.querySelector(`template[data-template="${resolved.key}"]`) || this.querySelector('template[data-template="missing"]');
        result.append(template.content.cloneNode(true));
        if (resolved.addon) {
          const addon = this.querySelector(`template[data-template="${resolved.addon}"]`);
          const target = result.querySelector('[data-addon]');
          if (target) target.append((addon || this.querySelector('template[data-template="missing"]')).content.cloneNode(true));
        }
        this.preservePreview(result);
      }
      const text = this.querySelector('[data-announcements]').dataset;
      this.querySelector('[data-status]').textContent = resolved.key === 'help' ? text.helpLabel : resolved.key ? `${text.resultLabel}: ${result.querySelector('h3')?.textContent || ''}` : resolved.next === 'size' ? text.nextSize : resolved.next === 'color' ? text.nextColor : resolved.next?.startsWith('water') ? text.nextWater : '';
    }
  }
  customElements.define('trek-fit-selector', TrekFitSelector);
})();
